import React, { useMemo } from 'react'
import { Box, CircularProgress, Link, Modal, Typography } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useSelector } from 'react-redux'
import { digitalAppApi } from '../../../../store/services/digitalAppApi'
import usePdfBlobUrl from '../../../../hooks/usePdfBlobUrl'
import { buildFacturaPrintParams } from '../../../../utils/buildFacturaPrintParams'
import IvaPriceSwitch from '../../../../components/IvaPriceSwitch/IvaPriceSwitch'

export default function FacturaDownloadModal({ open, onClose, facturaRow, pdfName }) {
  const priceWithIva = useSelector((state) => state.contextUI.PriceIVA)

  const queryArgs = useMemo(
    () => buildFacturaPrintParams(facturaRow, priceWithIva),
    [facturaRow, priceWithIva],
  )

  const skip = !open || !queryArgs?.orderIds

  const agrupadaQuery = digitalAppApi.useGetInvoiceByIdQuery(queryArgs, { skip })
  const detalladaQuery = digitalAppApi.useGetInvoiceDetailedQuery(queryArgs, { skip })

  const agrupadaUrl = usePdfBlobUrl(agrupadaQuery.data, agrupadaQuery.isSuccess)
  const detalladaUrl = usePdfBlobUrl(detalladaQuery.data, detalladaQuery.isSuccess)

  const loading = agrupadaQuery.isLoading || detalladaQuery.isLoading
  const linkSx = {
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'black',
    fontWeight: 600,
    border: '1px solid black',
    padding: 1,
    borderRadius: 2,
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
    pointerEvents: loading ? 'none' : 'auto',
    opacity: loading ? 0.5 : 1,
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fafafa',
          width: { xs: '92%', sm: 360 },
          maxWidth: 420,
          padding: 2,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          Descargar factura
        </Typography>

        <IvaPriceSwitch compact />

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={28} sx={{ color: '#5FC56E' }} />
          </Box>
        ) : (
          <>
            <Link sx={linkSx} href={agrupadaUrl || undefined} download={pdfName} component={agrupadaUrl ? 'a' : 'span'}>
              <DownloadIcon />
              Agrupada
            </Link>
            <Link sx={linkSx} href={detalladaUrl || undefined} download={pdfName} component={detalladaUrl ? 'a' : 'span'}>
              <DownloadIcon />
              Detallada
            </Link>
            <Link
              sx={linkSx}
              href={agrupadaUrl || undefined}
              target="_blank"
              rel="noreferrer noopener"
              component={agrupadaUrl ? 'a' : 'span'}
            >
              <OpenInNewIcon />
              Abrir agrupada
            </Link>
            <Link
              sx={linkSx}
              href={detalladaUrl || undefined}
              target="_blank"
              rel="noreferrer noopener"
              component={detalladaUrl ? 'a' : 'span'}
            >
              <OpenInNewIcon />
              Abrir detallada
            </Link>
          </>
        )}

        {(agrupadaQuery.isError || detalladaQuery.isError) && (
          <Typography color="error" variant="body2">
            Error al generar el PDF en el servidor.
          </Typography>
        )}
      </Box>
    </Modal>
  )
}
